<template>
  <div id="orderlist">
    <el-row>
      <h2>项目点管理列表</h2>
    </el-row>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:0" :model="searchForm" ref="searchForm">
        <el-col :xl="5" :lg="6" :md="24" :xs="24" :sm="24">
          <el-form-item label="状态：">
            <el-select v-model="searchForm.STATUS" placeholder="请选择">
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="5" :lg="6" :md="10" :xs="10" :sm="10">
          <el-form-item label="项目点名称：">
            <el-input placeholder="名称" minlength="2" maxlength="10" v-model="searchForm.NAME" clearable @keyup.enter.native="handleSearch()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xl="5" :lg="6" :md="10" :xs="10" :sm="10">
          <el-form-item label="城市：">
            <el-input placeholder="城市名称" v-model="searchForm.CONUNTY" clearable @keyup.enter.native="handleSearch()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xl="5" :lg="6" :md="10" :xs="10" :sm="10">
          <el-form-item label="结算模式：">
            <el-select v-model="searchForm.MODE" multiple collapse-tags placeholder="请选择">
              <el-option v-for="item in billingModeList" :key="item.SETTLEMENT_ID" :label="item.SETTLEMENT_NAME" :value="item.SETTLEMENT_ID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button id="search" @click="handleSearch()">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="small" @click="新增项目点()" style="margin-bottom:10px">新增</el-button>
        <el-button size="small" @click="importProjectDialog = true" style="margin-bottom:10px">导入项目点信息</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="projectSitesListData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="FINANCIAL_CODE" label="编码" width="150"></el-table-column>
          <el-table-column prop="NAME" label="项目点" width="150"></el-table-column>
          <el-table-column prop="ID" label="项目点ID" width="150"></el-table-column>
          <el-table-column prop="CITY" label="城市" min-width="150"></el-table-column>
          <el-table-column prop="ADDRESS" label="详细地址" min-width="150"></el-table-column>
          <el-table-column prop="SETTLEMENT_MODE_NAME" label="结算模式" min-width="150"></el-table-column>
          <el-table-column prop="IS_TAX_FREE" label="是否免税" min-width="150">
            <template slot-scope="scope">
              {{ showStatus(scope.row.IS_TAX_FREE) }}
            </template>
          </el-table-column>
          <el-table-column prop="START_DATE" label="合同开始日期" min-width="100"></el-table-column>
          <el-table-column prop="END_DATE" label="合同到期日期" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="370" v-if="changeOpera === '1'">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="manager(scope.row)" icon="el-icon-menu">档口管理</el-button>
              <el-button type="text" size="small" @click="allot(scope.row)" icon="el-icon-edit">人员分配</el-button>
              <el-button type="text" size="small" @click="partyAllot(scope.row)" icon="el-icon-edit">甲方配置</el-button>
              <el-button type="text" size="small" @click="basicDisposition(scope.row)" icon="el-icon-edit">基础配置</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="editUserForm(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color: #F56C6C" @click="stopUser(scope.row)">禁用</el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="290" v-else>
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-check" style="color:#67C23A" @click="startUser(scope.row)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalNum">
      </el-pagination>
    </div>
    <!-- 新增项目点模态框 -->
    <el-dialog title="新增项目点" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="财务编码：" :label-width="formLabelWidth" prop="financial_code">
          <el-input v-model="addForm.financial_code" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="name">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="addForm.name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="别名：" :label-width="formLabelWidth" prop="ab_name">
          <label slot="label">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="addForm.ab_name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="使用批次：" :label-width="formLabelWidth" prop="PROJECT_KIND">
          <el-select v-model="addForm.IS_WAREHOUSE_USE_BATCH" placeholder="请选择" filterable>
            <el-option v-for="item in BATCH_LIST" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <h3 style="color:red;">仓库设置为使用批次后无法调整回不使用批次，请谨慎操作</h3>
        <el-form-item label="开始日期：" :label-width="formLabelWidth" prop="startdate">
          <el-date-picker type="date" placeholder="选择日期" v-model="addForm.startdate" style="width: 100%;" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到期日期：" :label-width="formLabelWidth" prop="enddate">
          <el-date-picker type="date" placeholder="选择日期" v-model="addForm.enddate" style="width: 100%;" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="城市：" :label-width="formLabelWidth" prop="city">
          <label slot="label">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市：</label>
          <el-cascader size="small" :options="addForm.options" v-model="addForm.selectedOptions" @change="chooseCity" style="width: 100%" clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="address">
          <el-input v-model="addForm.address" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="下单限制：" :label-width="formLabelWidth" prop="limit">
          <el-select v-model="addForm.limit" placeholder="请选择下单限制" style="width:100%" clearable>
            <el-option label="工作日" value="1"></el-option>
            <el-option label="每天" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算日：" :label-width="formLabelWidth" prop="balance">
          <label slot="label">结&nbsp;&nbsp;算&nbsp;&nbsp;日：</label>
          <el-select v-model="addForm.balance" placeholder="请选择结算日" style="width:100%" clearable>
            <el-option v-for="num in 31" :key="num" :label="num + '号'" :value="num"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算模式：" :label-width="formLabelWidth" prop="billingMode">
          <label slot="label">结算模式：</label>
          <el-select v-model="addForm.billingMode" multiple collapse-tags placeholder="请选择结算模式" style="width:100%" clearable>
            <el-option v-for="item in billingModeList" :key="item.SETTLEMENT_ID" :label="item.SETTLEMENT_NAME" :value="item.SETTLEMENT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否免税：" :label-width="formLabelWidth" prop="isTaxExemption">
          <label slot="label">是否免税：</label>
          <el-select v-model="addForm.isTaxExemption" placeholder="请选择是否免税" style="width:100%">
            <el-option v-for="item in isTaxExemptionList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域：" :label-width="formLabelWidth">
          <el-input v-model="addForm.AREA" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型：" :label-width="formLabelWidth" prop="PROJECT_KIND">
          <el-select v-model="addForm.PROJECT_KIND" placeholder="请选择" filterable>
            <el-option v-for="item in PROJECT_KIND_LIST" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="食材成本率：" :label-width="formLabelWidth" prop="COST_RATE_CEILING">
          <el-input style="width:48%" v-model="addForm.COST_RATE_FLOOR" placeholder="最低食材成本率(0.1-1.0)" clearable>
          </el-input>
          <span>-</span>
          <el-input style="width:48%" v-model="addForm.COST_RATE_CEILING" placeholder="最高食材成本率(0.1-1.0)" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="展示供应商：" :label-width="formLabelWidth" prop="IS_PROJECT_SHOW_SUPPLIER">
          <el-switch v-model="addForm.IS_PROJECT_SHOW_SUPPLIER" active-text="展示" inactive-text="不展示" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="采购产品时展示供应商：" :label-width="formLabelWidth" prop="IS_SHOW_SUPPLIER">
          <el-switch v-model="addForm.IS_SHOW_SUPPLIER" active-text="展示" inactive-text="不展示" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button @click="submitAdd('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改项目点信息模态框 -->
    <el-dialog title="修改项目点" center :visible.sync="editFormVisible" width="600px" @close="close('editForm')">
      <el-form :model="editForm" ref="editForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="财务编码：" :label-width="formLabelWidth" prop="FINANCIAL_CODE">
          <el-input v-model="editForm.FINANCIAL_CODE" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="editForm.NAME" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="别名：" :label-width="formLabelWidth" prop="AB_NAME">
          <label slot="label">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="editForm.AB_NAME" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="开始日期：" :label-width="formLabelWidth" prop="START_DATE">
          <el-date-picker type="date" placeholder="选择日期" v-model="editForm.START_DATE" style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到期日期：" :label-width="formLabelWidth" prop="END_DATE">
          <el-date-picker type="date" placeholder="选择日期" v-model="editForm.END_DATE" style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="城市：" :label-width="formLabelWidth" prop="CITY">
          <label slot="label">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市：</label>
          <el-cascader size="small" :options="editForm.options" v-model="editForm.selectedOptions" @change="changeCity"
            style="width: 100%;height: 32px">
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="ADDRESS">
          <el-input v-model="editForm.ADDRESS" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="下单限制：" :label-width="formLabelWidth" prop="ORDER_LIMIT">
          <el-select v-model="editForm.LIMIT_DAY" placeholder="请选择下单限制" style="width:100%" @change="selectLimit">
            <el-option v-for="item in weekends" :key="item.label" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算日：" :label-width="formLabelWidth" prop="BALANCE_DAY">
          <label slot="label">结&nbsp;&nbsp;算&nbsp;&nbsp;日：</label>
          <el-select v-model="editForm.BALANCE_DAY" placeholder="请选择结算日" style="width:100%">
            <el-option v-for="num in 31" :key="num" :label="num + '号'" :value="num"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算模式：" :label-width="formLabelWidth" prop="SETTLEMENT_MODE_LIST">
          <label slot="label">结算模式：</label>
          <el-select v-model="editForm.SETTLEMENT_MODE_LIST" multiple collapse-tags placeholder="请选择结算模式" style="width:100%" clearable>
            <el-option v-for="item in billingModeList" :key="item.SETTLEMENT_ID" :label="item.SETTLEMENT_NAME" :value="item.SETTLEMENT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否免税：" :label-width="formLabelWidth" prop="IS_TAX_FREE">
          <label slot="label">是否免税：</label>
          <el-select v-model="editForm.IS_TAX_FREE" placeholder="请选择是否免税" style="width:100%">
            <el-option v-for="item in isTaxExemptionList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域：" :label-width="formLabelWidth">
          <el-input v-model="editForm.AREA" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型：" :label-width="formLabelWidth">
          <el-input v-model="editForm.PROJECT_KIND" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="食材成本率：" :label-width="formLabelWidth" prop="COST_RATE_CEILING">
          <el-input style="width:48%" v-model="editForm.COST_RATE_FLOOR" placeholder="最低食材成本率(0.1-1.0)" clearable>
          </el-input>
          <span>-</span>
          <el-input style="width:48%" v-model="editForm.COST_RATE_CEILING" placeholder="最高食材成本率(0.1-1.0)" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="展示供应商：" :label-width="formLabelWidth" prop="IS_PROJECT_SHOW_SUPPLIER">
          <el-switch v-model="editForm.IS_PROJECT_SHOW_SUPPLIER" active-text="展示" inactive-text="不展示" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="采购产品时展示供应商：" :label-width="formLabelWidth" prop="IS_SHOW_SUPPLIER">
          <el-switch v-model="editForm.IS_SHOW_SUPPLIER" active-text="展示" inactive-text="不展示" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button @click="submitEdit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--人员分配-->
    <el-dialog title="人员分配" center :visible.sync="allotFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="allotForm" ref="allotForm" :rules="rules" style="margin: 0;padding: 0">
        <el-form-item :label-width="formLabelWidth">
          <label slot="label">项目经理：</label>
          <template>
            <el-select v-model="allotForm.NEW_MANAGER_ID" filterable remote clearable reserve-keyword placeholder="请输入负责人"
              :remote-method="remoteMethod" style="width: 100%">
              <el-option v-for="item in personList" :key="item.USER_ID" :label="loadSelectContent(item)" :value="item.USER_ID">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <label slot="label">仓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;管：</label>
          <template>
            <el-select v-model="allotForm.DEPOT_MANAGER_ID" filterable remote clearable reserve-keyword placeholder="请输入负责人"
              :remote-method="remoteMethod" style="width: 100%" multiple>
              <el-option v-for="item in personList" :key="item.USER_ID" :label="loadSelectContent(item)" :value="item.USER_ID">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <label slot="label">厨&nbsp;&nbsp;&nbsp;师&nbsp;&nbsp;长：</label>
          <template>
            <el-select v-model="allotForm.HEAD_CHEF_ID" filterable remote clearable reserve-keyword placeholder="请输入厨师长"
              :remote-method="remoteMethod" style="width: 100%" multiple>
              <el-option v-for="item in personList" :key="item.USER_ID" :label="loadSelectContent(item)" :value="item.USER_ID">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('allotForm')">取 消</el-button>
        <el-button @click="submitAllot('allotForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--甲方人员分配-->
    <el-dialog title="甲方人员分配" center :visible.sync="partyAllotFormVisible" width="600px">
      <el-form :model="partyAllotForm" ref="partyAllotForm" :rules="rules" style="margin: 0;padding: 0">
        <el-form-item :label-width="formLabelWidth">
          <label slot="label">甲方人员：</label>
          <template>
            <el-select v-model="partyAllotForm.partyPer" filterable remote clearable reserve-keyword @change="selectPartyPer" placeholder="请输入甲方人员"
              style="width: 100%">
              <el-option v-for="item in partyPerList" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="partyAllotFormVisible = false">取 消</el-button>
        <el-button @click="$_submitPartyAllot('partyAllotForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入项目点 -->
    <el-dialog :visible.sync="importProjectDialog" title="导入项目点" width="400px" center :close-on-click-modal="false">
      <el-form ref="importProjectForm" v-model="importProjectForm">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :name="this.importProjectForm.excel" :multiple="false"
          :limit="1" accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importProjectDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitExportProject" :loading="loading12">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导入项目点出错提示 -->
    <el-dialog :visible.sync="errorDialog" title="错误原因" width="600px" center :close-on-click-modal="false">
      <div style="max-height:400px;overflow:auto">
        <div v-for="(item, index) in errorForm" :key="index">{{ item }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { regionData, CodeToText, TextToCode } from 'element-china-area-data';
import http from '@/api/base/http';
import date from '@/common/date';
import util from '@/common/util';
import {
  formalProjectList,
  addFormalProjectList,
  editFormalProjectList,
  allotFormalProjectList,
  stopFormalProjectList,
  getUser,
  getName,
  startProjectList,
  getPartyPer,
  getAllPartyPer,
  submitPartyAllot,
} from '@/api/projectSite';
import { getTCSettlementMode } from '../api/settlementModeManagement';

export default {
  data() {
    // 内容验证
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else {
        callback();
      }
    };
    const financial_code = /^[1-9]\d*\,\d*|[1-9]\d*$/;
    const validateFinancialCode = (rule, value, callback) => {
      if (value === '') {
        callback('请输入财务编码');
      } else if (financial_code.test(value)) {
        callback();
      } else {
        callback('请输入正确格式的财务编码');
      }
    };
    const validateRate = (rules, value, callback) => {
      // 0-1之间的数字(不保留、保留一到四位小数)
      const reg = /^0\.[0-9]{1,4}$|^0$|^1$|^1\.[0]{1,4}$/;
      const COST_RATE_CEILING = value;
      if (this.addFormVisible) {
        // 新增项目点模态框打开
        const { COST_RATE_FLOOR } = this.addForm;
        if (COST_RATE_CEILING && !COST_RATE_FLOOR) {
          callback('请输入最低食材成本率');
        } else if (COST_RATE_FLOOR && !COST_RATE_CEILING) {
          callback('请输入最高食材成本率');
        } else if (COST_RATE_CEILING && COST_RATE_FLOOR) {
          if (parseFloat(COST_RATE_CEILING) < parseFloat(COST_RATE_FLOOR)) {
            callback('最低食材成本率须小于最高食材成本率');
          }
          if (!reg.test(COST_RATE_CEILING) || !reg.test(COST_RATE_FLOOR)) {
            callback('食材成本率的范围为0至1');
          } else {
            callback();
          }
        } else if (!COST_RATE_CEILING && !COST_RATE_FLOOR) {
          callback();
        }
      } else if (this.editUserForm) {
        // 修改项目点模态框打开
        const { COST_RATE_FLOOR } = this.editForm;
        if (COST_RATE_CEILING && !COST_RATE_FLOOR) {
          callback('请输入最低食材成本率');
        } else if (COST_RATE_FLOOR && !COST_RATE_CEILING) {
          callback('请输入最高食材成本率');
        } else if (COST_RATE_CEILING && COST_RATE_FLOOR) {
          if (parseFloat(COST_RATE_CEILING) < parseFloat(COST_RATE_FLOOR)) {
            callback('最低食材成本率须小于最高食材成本率');
          }
          if (!reg.test(COST_RATE_CEILING) || !reg.test(COST_RATE_FLOOR)) {
            callback('食材成本率的范围为0至1');
          } else {
            callback();
          }
        } else if (!COST_RATE_CEILING && !COST_RATE_FLOOR) {
          callback();
        }
      }
    };
    return {
      BATCH_LIST: [{ id: 0, name: '不使用' }, { id: 1, name: '使用' }],
      PROJECT_KIND_LIST: [{
        value: '01',
        label: '企业',
      }, {
        value: '02',
        label: '学校',
      }, {
        value: '03',
        label: '医院',
      }, {
        value: '04',
        label: '银行',
      }, {
        value: '05',
        label: '政府',
      }, {
        value: '06',
        label: '园区',
      }, {
        value: '07',
        label: '宴会',
      }, {
        value: '08',
        label: '展览',
      }, {
        value: '09',
        label: '其他',
      }],
      loading: false,
      citys: [{
        value: '上海',
        label: '上海',
      }, {
        value: '杭州',
        label: '杭州',
      }],
      weekends: [
        {
          value: '0',
          label: '工作日',
        },
        {
          value: '1',
          label: '每日',
        },
      ],
      billingModeList: [],
      isTaxExemptionList: [
        { value: 0, label: '免税' },
        { value: 1, label: '非免税' },
      ],
      value1: '',
      status: [
        {
          value: '1',
          label: '在用',
        },
        {
          value: '0',
          label: '禁用',
        },
      ],
      projectSitesListData: [
        {
          FINANCIAL_CODE: '01.004',
          NAME: '浏阳一中',
          CITY: '浏阳市',
          START_DATE: '2022-05-12',
          END_DATE: '2022-05-12',
        },
      ],
      editFormVisible: false,
      allotFormVisible: false,
      partyAllotFormVisible: false,
      partyAllotForm: {
        partyPer: '',
      },
      EMPLOYEE_ID: 0,
      partyPerList: [],
      pageSize: 20,
      currentPage: 1,
      index: 0,
      totalNum: 6,
      // 新增form表单
      addForm: {
        financial_code: '',
        // code: '',
        name: '',
        ab_name: '',
        startdate: '',
        enddate: '',
        city: '',
        address: '',
        limit: '',
        balance: '',
        billingMode: [],
        rate: '',
        options: regionData,
        selectedOptions: [],
        COST_RATE_CEILING: '',
        COST_RATE_FLOOR: '',
        isTaxExemption: '',
        IS_WAREHOUSE_USE_BATCH: this.是否使用批次,
        IS_PROJECT_SHOW_SUPPLIER: 1,
        IS_SHOW_SUPPLIER: 1,
      },
      // 修改
      editForm: {
        START_DATE: '',
        END_DATE: '',
        ORDER_LIMIT: '',
        BALANCE_DAY: '',
        LIMIT_DAY: '',
        options: regionData,
        selectedOptions: [],
        COST_RATE_CEILING: '',
        COST_RATE_FLOOR: '',
        SETTLEMENT_MODE_LIST: [],
        IS_TAX_FREE: '',
        IS_PROJECT_SHOW_SUPPLIER: '',
        IS_SHOW_SUPPLIER: '',
      },
      allotForm: {
        ID: '',
        PROJECT_ID: '',
        NAME: '',
        MANAGER_ID: '',
        NEW_MANAGER_ID: '',
        DEPOT_MANAGER_ID: [],
        MANAGER: '',
        HEAD_CHEF_ID: [],
      },

      // 搜索
      searchForm: {
        NAME: '',
        CITY: '',
        MANAGER: '',
        DEPOT_MANAGER: '',
        options: regionData,
        selectedOptions: [],
        STATUS: '1',
        MODE: [],
      },
      personDict: {},
      rules: {
        financial_code: [{ required: true, validator: validateFinancialCode, trigger: 'blur' }],
        // code: [{ required: true, validator: validateCode, trigger: 'blur' }],
        name: [{ required: true, validator: validateName, trigger: 'blur' }],
        ab_name: [{ required: true, validator: validateName, trigger: 'blur' }],
        startdate: [{
          type: 'date', required: true, message: '请选择开始日期', trigger: 'change',
        }],
        enddate: [{
          type: 'date', required: true, message: '请选择结束日期', trigger: 'change',
        }],
        limit: [{ required: true, message: '请选择下单限制', trigger: 'change' }],
        city: [{ required: true, message: '请选择城市', trigger: 'change' }],
        FINANCIAL_CODE: [{ required: true, validator: validateFinancialCode, trigger: 'blur' }],
        NAME: [{ required: true, validator: validateName, trigger: 'blur' }],
        START_DATE: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        END_DATE: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
        ORDER_LIMIT: [{ required: true, message: '请选择下单限制', trigger: 'change' }],
        CITY: [{ required: true, message: '请选择城市', trigger: 'change' }],
        address: [{ required: true, validator: validateName, trigger: 'blur' }],
        ADDRESS: [{ required: true, validator: validateName, trigger: 'blur' }],
        AB_NAME: [{ required: true, validator: validateName, trigger: 'blur' }],
        // BALANCE_DAY: [{required: true, validator: validateCode, trigger: 'blur'}],
        balance: [{ required: true, message: '请选择结算日', trigger: 'blur' }],
        SETTLEMENT_NAME: [{ required: true, message: '请选择结算模式', trigger: 'blur' }],
        COST_RATE_CEILING: [{ validator: validateRate, trigger: 'blur' }],
        PROJECT_KIND: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      },
      formLabelWidth: '100px',
      partyRow: {},
      //   导入项目点
      importProjectDialog: false,
      importProjectForm: {
        excel: 'tmp',
      },
      loading12: false,
      addFormVisible: false,
      fileList: [],
      errorDialog: false,
      errorForm: [],
      changeOpera: '1',
      projectPersonDict: {},
    };
  },
  computed: {
    personList() {
      return Object.values(this.personDict);
    },
  },
  created() {
    this.拉取是否使用批次();
    this.getBillingModeList();
  },
  methods: {
    新增项目点() {
      this.addFormVisible = true;
      this.addForm.IS_WAREHOUSE_USE_BATCH = this.是否使用批次;
    },
    拉取是否使用批次() {
      const data = {
        SERVICE_ID: '10001',
        OTYPE: 39,
        TC_ID: sessionStorage.getItem('companyId'),
      };
      http.post(data).then((res) => {
        this.是否使用批次 = res[0].PROJECT_USE_BATCH;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    showStatus(status) {
      if (status == 0) {
        return '免税';
      }
      return '非免税';
    },
    handleChange(value) {
      if (value.length > 0) {
        const city = `${CodeToText[value[0]]}/${CodeToText[value[1]]}/${CodeToText[value[2]]}`;
        this.searchForm.CITY = city;
      } else {
        this.searchForm.CITY = '';
      }
    },
    chooseCity(value) {
      const city = `${CodeToText[value[0]]}/${CodeToText[value[1]]}/${CodeToText[value[2]]}`;
      this.addForm.city = city;
    },
    changeCity(value) {
      const city = `${CodeToText[value[0]]}/${CodeToText[value[1]]}/${CodeToText[value[2]]}`;
      this.editForm.CITY = city;
    },
    // 获取项目点列表
    queryProjectSitesListData() {
      const data = {
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      if (this.searchForm.STATUS) {
        data.STATUS = Number(this.searchForm.STATUS);
      }
      if (this.searchForm.NAME) {
        data.NAME = this.searchForm.NAME;
      }
      if (this.searchForm.CONUNTY) {
        data.CITY = this.searchForm.CONUNTY;
      }
      if (this.searchForm.MODE.length != 0) {
        data.SETTLEMENT_MODE_LIST = this.searchForm.MODE;
      }
      formalProjectList(data).then((res) => {
        if (res.length != 0) {
          this.projectSitesListData = res.length > 0 ? res[0].OP_ROLE : [];
          this.totalNum = res.length > 0 ? res[0].TOTAL_COUNT : 0;
        } else {
          this.projectSitesListData = res;
        }
        if (this.searchForm.STATUS) {
          this.changeOpera = this.searchForm.STATUS;
        }
        sessionStorage.setItem('FORMAL_PROJECT_SITES_MANAGE_SEARCH', this.searchForm.NAME);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增项目点
    submitAdd(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = {
                FINANCIAL_CODE: this.addForm.financial_code,
                NAME: this.addForm.name,
                AB_NAME: this.addForm.ab_name,
                START_DATE: date(this.addForm.startdate, '%F'),
                END_DATE: date(this.addForm.enddate, '%F'),
                CITY: this.addForm.city,
                ADDRESS: this.addForm.address,
                ORDER_LIMIT: this.addForm.limit,
                BALANCE_DAY: this.addForm.balance,
                IS_WAREHOUSE_USE_BATCH: this.addForm.IS_WAREHOUSE_USE_BATCH,
                IS_PROJECT_SHOW_SUPPLIER: this.addForm.IS_PROJECT_SHOW_SUPPLIER,
                IS_SHOW_SUPPLIER: this.addForm.IS_SHOW_SUPPLIER,
              };
              if (this.addForm.AREA) {
                data.AREA = this.addForm.AREA;
              }
              if (this.addForm.PROJECT_KIND) {
                data.PROJECT_KIND = this.addForm.PROJECT_KIND;
              }
              if (this.addForm.COST_RATE_CEILING && this.addForm.COST_RATE_FLOOR) {
                data.COST_RATE_CEILING = this.addForm.COST_RATE_CEILING;
                data.COST_RATE_FLOOR = this.addForm.COST_RATE_FLOOR;
              }
              if (this.addForm.billingMode.length != 0) {
                data.SETTLEMENT_MODE_LIST = this.addForm.billingMode;
              }
              if (this.addForm.IS_TAX_FREE !== '') {
                data.IS_TAX_FREE = this.addForm.isTaxExemption;
              }
              addFormalProjectList(data).then((res) => {
                this.$message.show({ text: '新增项目点成功', type: 'success' });
                this.queryProjectSitesListData();
                this.$refs[formName].resetFields();
                this.addFormVisible = false;
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally { }
      }
    },
    // 修改模态框
    editUserForm(row) {
      this.editFormVisible = true;
      this.$nextTick(() => {
        this.editForm = Object.assign(this.editForm, row);
        const SETTLEMENT_MODE_NAME = this.editForm.SETTLEMENT_MODE_NAME.split('/');
        this.billingModeList.forEach((ele) => {
          const tag = SETTLEMENT_MODE_NAME.indexOf(ele.SETTLEMENT_NAME);
          if (tag > -1) {
            this.editForm.SETTLEMENT_MODE_LIST.push(ele.SETTLEMENT_ID);
          }
        });
        const cities = this.editForm.CITY.split('/');
        this.editForm.selectedOptions.push(TextToCode[cities[0]].code);
        this.editForm.selectedOptions.push(TextToCode[cities[0]][cities[1]].code);
        this.editForm.selectedOptions.push(TextToCode[cities[0]][cities[1]][cities[2]].code);
        Object.assign(this.editForm, { LIMIT_DAY: Number(row.ORDER_LIMIT) === 0 ? '工作日' : '每日' });
      });
    },
    // 修改项目点信息
    submitEdit(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = { // http请求的参数
                PROJECT_ID: this.editForm.ID,
                NAME: this.editForm.NAME,
                FINANCIAL_CODE: this.editForm.FINANCIAL_CODE,
                // CODE: this.editForm.CODE,
                START_DATE: date(this.editForm.START_DATE, '%F'),
                END_DATE: date(this.editForm.END_DATE, '%F'),
                CITY: this.editForm.CITY,
                ADDRESS: this.editForm.ADDRESS,
                AB_NAME: this.editForm.AB_NAME,
                ORDER_LIMIT: this.editForm.ORDER_LIMIT,
                BALANCE_DAY: this.editForm.BALANCE_DAY,
                MANAGER_ID: this.editForm.MANAGER_ID,
                DEPOT_MANAGER_ID: this.editForm.DEPOT_MANAGER_ID,
                SENIOR_CS_ID: this.editForm.SENIOR_CS_ID,
                AREA: this.editForm.AREA,
                PROJECT_KIND: this.editForm.PROJECT_KIND,
                COST_RATE_CEILING: this.editForm.COST_RATE_CEILING,
                COST_RATE_FLOOR: this.editForm.COST_RATE_FLOOR,
                IS_PROJECT_SHOW_SUPPLIER: this.editForm.IS_PROJECT_SHOW_SUPPLIER,
                IS_SHOW_SUPPLIER: this.editForm.IS_SHOW_SUPPLIER,
              };
              // if (this.editForm.CODE) {
              //   const reg = /[\u4E00-\u9FA5]/g;
              //   if (reg.test(this.editForm.CODE)) {
              //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
              //     document.body.style.cursor = 'default';
              //     return false;
              //   }
              // }
              if (this.editForm.SETTLEMENT_MODE_LIST.length != 0) {
                data.SETTLEMENT_MODE_LIST = this.editForm.SETTLEMENT_MODE_LIST;
              } else {
                this.$message.show({ text: '请选择结算模式', type: 'warning' });
                document.body.style.cursor = 'default';
                return false;
              }
              if (this.editForm.IS_TAX_FREE !== '') {
                data.IS_TAX_FREE = this.editForm.IS_TAX_FREE;
              }
              editFormalProjectList(data).then((res) => {
                this.$message.show({ text: '修改项目点信息成功', type: 'success' });
                this.queryProjectSitesListData();
                this.$refs[formName].resetFields();
                this.editFormVisible = false;
                // this.editForm.SETTLEMENT_MODE_LIST = [];
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
              }).finally(() => {
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 禁用项目点
    stopUser(row) {
      this.$confirm('您确定将该项目点禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          PROJECT_ID: row.ID,
        };
        stopFormalProjectList(data).then((res) => {
          this.queryProjectSitesListData();
          this.$message.show({
            text: '禁用成功',
            type: 'success',
          });
        }).catch((error) => {
          this.$message.show({
            type: 'error',
            text: error,
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 启用项目点
    startUser(row) {
      this.$confirm('您确定将该项目点启用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          PROJECT_ID: row.ID,
        };
        startProjectList(data).then((res) => {
          this.$message.show({
            text: '启用成功',
            type: 'success',
          });
          this.queryProjectSitesListData();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 关闭弹窗
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.editForm.SETTLEMENT_MODE_LIST = [];
    },
    // 档口管理入口
    manager(row) {
      this.$router.push({ name: 'archivesMouthsManage', params: { siteId: row.ID } });
    },
    // 人员分配弹窗
    async allot(row) {
      this.allotForm = util.deepCopy({
        ...this.allotForm, PROJECT_ID: row.ID, MANAGER_ID: row.MANAGER_ID, NEW_MANAGER_ID: row.MANAGER_ID,
      });
      this.personDict = {};
      await this.queryManagerName();
      this.queryDepotAndChef();
      this.allotFormVisible = true;
    },
    // 点击甲方人员分配
    partyAllot(row) {
      this.partyRow = row;
      this.partyAllotFormVisible = true;
      this.partyAllotForm.partyPer = '';
      this.$_getAllPartyPer();
      this.$_getPartyPer(row.ID);
    },
    // 获取所有甲方人员
    $_getAllPartyPer() {
      getAllPartyPer().then((res) => {
        this.partyPerList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 获取某个项目点的甲方人员
    $_getPartyPer(ID) {
      const data = {
        PROJECT_ID: ID,
      };
      getPartyPer(data).then((res) => {
        if (res.length === 0) {
          this.partyAllotForm.partyPer = '';
          this.EMPLOYEE_ID = 0;
        } else {
          this.partyAllotForm.partyPer = res[0].NAME;
          this.EMPLOYEE_ID = res[0].EMPLOYEE_ID;
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 选择甲方人员
    selectPartyPer(e) {
      this.EMPLOYEE_ID = e;
    },
    // 提交甲方人员配置
    $_submitPartyAllot() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            EMPLOYEE_ID: Number(this.EMPLOYEE_ID),
            PROJECT_ID: this.partyRow.ID,
          };
          submitPartyAllot(data).then((res) => {
            this.$message.show({ text: '分配成功', type: 'success' });
            this.partyAllotFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((err) => {
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    remoteMethod(query) {
      if (query.length >= 2) {
        this.__getPersonName(query);
      }
    },
    // 获取负责人
    __getPersonName(name) {
      const data = {
        USER_NAME: name,
      };
      getUser(data).then((res) => {
        if (res[0]) {
          for (const { ID: USER_ID, NAME: USER_NAME, CELLPHONE: USER_CELLPHONE } of res) {
            if (!this.personDict[USER_ID]) this.$set(this.personDict, USER_ID, { USER_ID, USER_NAME, USER_CELLPHONE });
          }
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查询项目经理姓名
    async queryManagerName() {
      const data = {
        TC_USER_ID: this.allotForm.MANAGER_ID,
      };

      await getName(data).then(async (res) => {
        if (res.length != 0) {
          this.allotForm.MANAGER = res[0].NAME;
          await getUser({ USER_NAME: res[0].NAME }).then((res2) => {
            this.$set(this.personDict, res2[0].ID, res2.map(({ ID: USER_ID, NAME: USER_NAME, CELLPHONE: USER_CELLPHONE }) => ({
              USER_ID, USER_NAME, USER_CELLPHONE,
            }))[0]);
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查询仓管姓名
    async queryDepotName() {
      const data = {
        TC_USER_ID: this.allotForm.DEPOT_MANAGER_ID,
      };
      await getName(data).then((res) => {
        if (res.length != 0) {
          this.allotForm.DEPOT_MANAGER = res[0].NAME;
        } else {
          this.allotForm.DEPOT_MANAGER = '';
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查询厨师长姓名
    async queryChefName() {
      const data = {
        TC_USER_ID: this.allotForm.HEAD_CHEF_ID,
      };
      await getName(data).then((res) => {
        if (res.length != 0) {
          this.allotForm.HEAD_CHEF = res[0].NAME;
        } else {
          this.allotForm.HEAD_CHEF = '';
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 显示负责人姓名电话
    loadSelectContent(item) {
      return `${item.USER_NAME}--${item.USER_CELLPHONE}`;
    },
    // 人员分配
    async submitAllot(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          if (this.allotForm.MANAGER_ID != this.allotForm.NEW_MANAGER_ID) {
            const params = {
              PROJECT_ID: this.allotForm.PROJECT_ID,
              MANAGER_ID: this.allotForm.NEW_MANAGER_ID,
            };
            await allotFormalProjectList(params).then(() => {
            }).catch((error) => {
              this.$message.show({
                text: error,
                type: 'error',
              });
            });
          }
          const obj2 = this.allotForm.DEPOT_MANAGER_ID.reduce((obj, x) => { obj[`${x}+2`] = 1; return obj; }, {});
          const obj4 = this.allotForm.HEAD_CHEF_ID.reduce((obj, x) => { obj[`${x}+4`] = 1; return obj; }, {});
          const { added, removed } = this.compareObjectKeysFast(this.projectPersonDict, { ...obj2, ...obj4 });

          const errList = [];
          if (added.length) {
            for (const key of added) {
              const [USER_ID, USER_TYPE] = key.split('+');

              const params = {
                SERVICE_ID: '10002',
                OTYPE: 13,
                PROJECT_ID: this.allotForm.PROJECT_ID,
                USER_TYPE,
                USER_ID,
              };
              try {
                // eslint-disable-next-line no-await-in-loop
                await http.post(params);
              } catch (err) {
                errList.push(err);
              }
            }
          }
          if (removed.length) {
            for (const key of removed) {
              const params = {
                SERVICE_ID: '10002',
                OTYPE: 14,
                PROJECT_ID: this.allotForm.PROJECT_ID,
                RELATION_ID: this.projectPersonDict[key].RELATION_ID,
              };
              try {
                // eslint-disable-next-line no-await-in-loop
                await http.post(params);
              } catch (err) {
                errList.push(err);
              }
            }
          }
          if (errList.length) {
            this.$message.show({
              text: errList.join(','),
              type: 'error',
            });
          } else {
            this.allotFormVisible = false;
            this.$refs[formName].resetFields();
            this.personDict = {};
            this.projectPersonDict = {};
            this.$message.show({
              text: '人员分配成功',
              type: 'success',
            });
          }
          this.queryProjectSitesListData();
          document.body.style.cursor = 'default';
        } finally { }
      }
    },
    handleCurrentChange(e) {
      this.currentPage = e || this.currentPage;
      this.queryProjectSitesListData();
    },
    selectLimit(e) {
      this.editForm.ORDER_LIMIT = e;
      this.editForm.LIMIT_DAY = Number(e) === 0 ? '工作日' : '每天';
    },
    handleSearch() {
      this.currentPage = 1;
      this.queryProjectSitesListData();
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    // 提交导入项目点
    submitExportProject() {
      this.loading12 = true;
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 2,
        TC_ID: sessionStorage.getItem('companyId'),
        FILE_NAME: this.file_name,
      };
      http.post(params).then((result) => {
        this.loading12 = false;
        if (result.length === 0) {
          this.importProjectDialog = false;
          this.queryProjectSitesListData();
          this.$message.show({ text: '项目点导入完成', type: 'success' });
        } else {
          this.$message.show({ text: result[0], type: 'warning' });
          this.errorForm = result;
          this.errorForm.splice(0, 1);
          this.importProjectDialog = false;
          this.queryProjectSitesListData();
          this.errorDialog = true;
        }
      }).catch((error) => {
        this.loading12 = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 基础配置
    basicDisposition(row) {
      sessionStorage.setItem('projectInfo', JSON.stringify(row));
      this.$router.push({ name: 'basicConfiguration', params: { siteId: row.ID } });
    },
    getBillingModeList() {
      getTCSettlementMode().then((res) => {
        this.billingModeList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryDepotAndChef() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 12,
        PROJECT_ID: this.allotForm.PROJECT_ID,
      };
      http.post(params).then((res) => {
        this.allotForm.DEPOT_MANAGER_ID = res.filter(({ USER_TYPE }) => USER_TYPE == 2).map(({ USER_ID }) => USER_ID);
        this.allotForm.HEAD_CHEF_ID = res.filter(({ USER_TYPE }) => USER_TYPE == 4).map(({ USER_ID }) => USER_ID);
        this.projectPersonDict = res.reduce((dict, x) => { dict[`${x.USER_ID}+${x.USER_TYPE}`] = x; return dict; }, {});
        for (const { USER_ID, USER_NAME, USER_CELLPHONE } of res) {
          if (!this.personDict[USER_ID]) this.$set(this.personDict, USER_ID, { USER_ID, USER_NAME, USER_CELLPHONE });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    compareObjectKeysFast(objA, objB) {
      const setA = new Set(Object.keys(objA));
      const setB = new Set(Object.keys(objB));

      const added = [...setB].filter((key) => !setA.has(key));
      const removed = [...setA].filter((key) => !setB.has(key));
      const unchanged = [...setA].filter((key) => setB.has(key));

      return { added, removed, unchanged };
    },
  },
  mounted() {
    if ('FORMAL_PROJECT_SITES_MANAGE_SEARCH' in sessionStorage) {
      this.searchForm.NAME = sessionStorage.getItem('FORMAL_PROJECT_SITES_MANAGE_SEARCH');
    }
    this.queryProjectSitesListData();
  },

};
</script>
<style>
.block {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/formalProjectSitesManage.vue